import type { TFunction } from "i18next";
import { isTranslationKey, resolveDisplayText } from "modules/record/shared/services/recordMetadataLabels";

/**
 * `sys_fluss_definitions.name` may hold a translation key (TranslatableInput) or a
 * literal string from before that change. Centralized here so every screen that
 * displays or searches a definition name resolves it the same way.
 */
export const flussDefinitionLabel = (t: TFunction, name?: string | null): string =>
    String(resolveDisplayText(t, name || "") || "");

/** A missing description translation should leave no raw key on screen or in copy forms. */
export const flussDefinitionDescription = (t: TFunction, description?: string | null): string => {
    const value = flussDefinitionLabel(t, description);
    return value === description && isTranslationKey(description || "") ? "" : value;
};
